// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('list_copy');

// eslint-disable-next-line @trello/no-module-logic
export const ListCopyTemplate = t.renderable(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ canCopyOpen, canCopyTotal, name }: any) =>
    t.div(function () {
      const canCopy = canCopyOpen && canCopyTotal;
      t.label(() => t.format('name'));
      t.textarea('.js-autofocus', { name: 'name' }, () => t.text(name));

      t.span(
        '.js-limit-exceeded.error',
        { class: t.classify({ hide: canCopy }) },
        () =>
          t.format(
            !canCopyOpen ? 'open-limit-exceeded' : 'total-limit-exceeded',
          ),
      );

      return t.input('.nch-button.nch-button--primary.wide.js-submit', {
        type: 'submit',
        value: t.l('create-list'),
        disabled: !canCopy,
      });
    }),
);
